export enum ErrorSignalTypes {
  System = 'system',
  Api = 'api',
  Routing = 'routing',
  Unknown = 'unknown',
}
